import { sva } from '@allenai/varnish-panda-runtime/css';
import type { RecipeVariantProps } from '@allenai/varnish-panda-runtime/types';

const inputRecipe = sva({
    slots: [
        'root',
        'container',
        'input',
        'startControls',
        'endControls',
        'label',
        'description',
        'error',
    ],
    base: {
        root: {
            boxSizing: 'border-box',
        },
        container: {},
        input: {
            boxSizing: 'border-box',
            textStyle: 'inherit',
            layerStyle: 'controlTransparent', // this has padding/border/color/bgcolor
            appearance: 'none',
            outline: '0',

            _placeholder: {
                color: 'text.placeholder',
            },
            _invalid: {
                _placeholder: {
                    color: 'text.error',
                },
            },
        },
        label: {},
        description: {},
        error: {},
        // controls, TBD
        startControls: {},
        endControls: {},
    },
    variants: {
        variant: {
            // these are being used to expose variants that are passed to container
            // could be moved out unless we need to adjust <input> based on these
            contained: {},
            outlined: {},
        },
        size: {
            // these set the height, using line-height for a single line works well,
            // line height keeps the <input> text centered in the input
            small: {
                input: {
                    lineHeight: '[16px]',
                },
            },
            medium: {
                input: {
                    lineHeight: '[20px]',
                },
            },
            large: {
                input: {
                    lineHeight: '[24px]',
                },
            },
        },
        shape: {
            // these are being used to expose variants that are passed to container
            // could be moved out unless we need to adjust <input> based on these
            box: {},
            rounded: {},
        },
        fullWidth: {
            false: {},
            true: {
                // this is needed for both the container and the input, afaict
                root: {
                    width: '[100%]',
                },
                input: {
                    width: '[100%]',
                },
            },
        },
    },
    defaultVariants: {
        variant: 'outlined',
        shape: 'box',
        size: 'medium',
        fullWidth: false,
    },
});

type InputRecipeProps = Exclude<RecipeVariantProps<typeof inputRecipe>, undefined>;

export { inputRecipe, inputRecipe as default };
export type { InputRecipeProps };
